import { BookingStatusText } from "../constants/bookingStatus";

export const formattedDate = (date) => {
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const d = new Date();
  const today = new Date(date);
  const yyyy = today.getFullYear();
  let mm = today.getMonth() + 1; // Months start at 0!
  let dd = today.getDate();

  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;

  // const formattedToday = dd + "-" + mm + "-" + yyyy;
  const formattedToday = dd + "-" + monthNames[today.getMonth()] + "-" + yyyy;
  return formattedToday;
};

export const formattedDateTime = (date) => {
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const today = new Date(date);
  const yyyy = today.getFullYear();
  let dd = today.getDate();
  let hours = today.getHours();
  let minutes = today.getMinutes();

  // Determine AM/PM
  const ampm = hours >= 12 ? 'PM' : 'AM';

  // Convert to 12-hour format
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'

  // Add leading zeros
  if (dd < 10) dd = "0" + dd;
  if (minutes < 10) minutes = "0" + minutes;

  const formattedToday = dd + "-" + monthNames[today.getMonth()] + "-" + yyyy + " " + hours + ":" + minutes + " " + ampm;
  return formattedToday;
};

export const getBookingStatus = (status) => {
  return BookingStatusText[status] || "Unknown Status";
};

const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];

// appointment_date may already be formatted as "dd-Mon-yyyy" (see XrayBooking.js) or a raw Date/ISO string
const parseAppointmentDate = (appointment_date) => {
  if (typeof appointment_date === "string") {
    const match = appointment_date.match(/^(\d{1,2})-([A-Za-z]{3})-(\d{4})$/);
    if (match) {
      const [, dd, mon, yyyy] = match;
      const monthIndex = monthNames.indexOf(mon);
      if (monthIndex !== -1) {
        return new Date(Number(yyyy), monthIndex, Number(dd));
      }
    }
  }
  return new Date(appointment_date);
};

// appointment_slot is formatted like "09:00 am to 09:30 am"
export const hasSlotStarted = (appointment_date, appointment_slot) => {
  if (!appointment_date || !appointment_slot) return false;

  const slotDate = parseAppointmentDate(appointment_date);
  if (isNaN(slotDate.getTime())) return false;

  const timePart = appointment_slot.split(" to ")[0];
  const [timeStr, period] = timePart.trim().split(" ");
  if (!timeStr || !period) return false;
  let [h, m] = timeStr.split(":").map(Number);
  if (period.toLowerCase() === "pm" && h !== 12) h += 12;
  if (period.toLowerCase() === "am" && h === 12) h = 0;

  const slotStart = new Date(
    slotDate.getFullYear(),
    slotDate.getMonth(),
    slotDate.getDate(),
    h,
    m
  );

  const nowIST = new Date(new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));

  return nowIST >= slotStart;
};
